import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../../assets/loaders";

const LazyComponent = lazy(() => import("./employeesMain"));

export default function Employees() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
